import React from 'react';

import { SourceFavicon } from './SourceFavicon';
import { FaviconStackLabel, FaviconStackWrapper, FaviconTileList } from './webSearch.styles';
import { ThinkingSource } from './webSearch.types';
import { getHostname } from './webSearch.utils';

const MAX_VISIBLE = 4;

interface SourceFaviconStackProps {
  sources: ThinkingSource[];
  label: string;
}

export const SourceFaviconStack = ({ sources, label }: SourceFaviconStackProps) => {
  const uniqueByDomain = sources.filter((source, i) => {
    const key = getHostname(source.url) || source.url;
    return sources.findIndex((s) => (getHostname(s.url) || s.url) === key) === i;
  });
  const visible = uniqueByDomain.slice(0, MAX_VISIBLE);

  return (
    <FaviconStackWrapper>
      <FaviconTileList>
        {visible.map((source) => (
          <SourceFavicon key={source.url} url={source.url} title={source.title} />
        ))}
      </FaviconTileList>
      <FaviconStackLabel>{label}</FaviconStackLabel>
    </FaviconStackWrapper>
  );
};
